module.exports = __webpack_public_path__ + "static/media/bg-brand-2.51017c76.png";